/**
 * Los colores se organizan en categorías:
 * - primary: Colores principales de la marca
 * - sidebar: Colores del menú lateral
 * - header: Colores del encabezado
 * - background: Colores de fondo
 * - text: Colores de texto
 * - border: Colores de bordes
 * - status: Colores de estado (éxito, error, etc.)
 */

export const colors = {
  // ===== COLORES PRIMARIOS (Marca) =====
  primary: {
    main: '#BA955E', // Dorado principal (botones, acentos fuertes)
    light: '#CCA259', // Dorado claro (hover, estados activos)
    dark: '#534430', // Dorado oscuro (borde, pressed)
    gradient: {
      start: '#A1773D', // Inicio del gradiente dorado
      end: '#BA955E', // Fin del gradiente (brillo metálico)
    },
  },

  // ===== COLORES DEL SIDEBAR =====
  sidebar: {
    background: '#515151', // Fondo principal oscuro (azul-negro)
    backgroundHover: '#74b567', // Fondo al hacer hover
    backgroundActive: '#74b567', // Fondo del ítem activo
    text: '#BA955E', // Texto normal del sidebar
    textHover: '#FFFFFF', // Texto al hacer hover
    textActive: '#BA955E', // Texto del ítem activo (dorado claro)
    border: '#BA955E', // Borde del sidebar
    borderHover: '#3A3B4D', // Borde al hover
    toggleBackground: '#515151', // Fondo del botón toggle
    gradiant: {
      to: '#515151',
      bottom: '#141414'

    }
  },

  // ===== COLORES DEL HEADER =====
  header: {
    background: '#515151', // Fondo del header (mismo tono que el fondo principal)
    border: '#2A2B3C', // Borde inferior del header
    text: '#BA955E', // Texto del header en dorado claro
  },

  // ===== COLORES DE FONDO =====
  background: {
    main: '#F3F3F3', // Fondo principal de la aplicación
    light: '#111322', // Fondo ligeramente más claro (cards, secciones)
    white: '#FFFFFF', // Blanco puro (para secciones puntuales / modales)
    gray: '#1B1C2A', // Gris azulado para contenedores secundarios
  },

  // ===== COLORES DE TEXTO =====
  text: {
    primary: '#FFFFFF', // Texto principal sobre fondo oscuro
    secondary: '#C0C0D0', // Texto secundario (metadatos, descripciones)
    tertiary: '#9A9AB0', // Texto terciario / menos relevante
    light: '#BA955E', // Texto destacado en dorado claro
    white: '#FFFFFF', // Alias para blanco
    dark: '#000000', // Texto sobre fondos muy claros (casos específicos)
  },

  // ===== COLORES DE BORDES =====
  border: {
    light: '#2A2B3C', // Borde claro sobre fondo oscuro
    medium: '#3A3B4D', // Borde medio
    dark: '#4C4D60', // Borde más marcado
  },

  // ===== COLORES DE ESTADO =====
  status: {
    success: '#52c41a', // Éxito (verde)
    error: '#ff4d4f', // Error (rojo)
    warning: '#faad14', // Advertencia (amarillo)
    info: '#1890ff', // Información (azul)
  },

  // ===== COLORES ESPECIALES =====
  special: {
    avatar: '#CCA259', // Fondo de avatar por defecto en tono dorado
    overlay: 'rgba(0, 0, 0, 0.7)', // Overlay oscuro para modales
    field: '#23C469', // Verde césped para detalles futboleros
    trophy: '#F5B301', // Dorado vivo tipo trofeo
  },
};

export const getColor = (path, fallback = '#000000') => {
  const keys = path.split('.');
  let value = colors;

  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return fallback;
    }
  }

  return typeof value === 'string' ? value : fallback;
};

export default colors;
